export default __webpack_public_path__ + "assets/images/4a436df4c8df4f8064a356a60cab222f.png";